import { SettlementContractRequest } from './service-models/settlement/SettlementContractRequest';
import { SettlementContractResult } from './service-models/settlement/SettlementContractResult';
import { BaseService } from './BaseService';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';

/**
 * 締結処理サービス
 */
export class SettlementService extends BaseService {
	// サービス メソッド  --------------------------------------------------------
	/**
	 * クレジット決済
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public settlementByCredit(viewCore: WprBaseViewCore, request: SettlementContractRequest, resMethod: (result: SettlementContractResult) => void): void {
		return this.doPost(viewCore, '/settlement/credit', request, resMethod);
	}
	
	/**
	 * PayPay決済要求
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public requestAuthPayPay(viewCore: WprBaseViewCore, request: SettlementContractRequest, resMethod: (result: SettlementContractResult) => void): void {
		return this.doPost(viewCore, '/settlement/reqpaypay', request, resMethod);
	}

	// /**
	//  * PayPay決済
	//  * @param viewCore ビュー情報
	//  * @param request リクエスト情報
	//  * @param resMethod 結果処理メソッド
	//  */
	// public settlementByPayPay(viewCore: WprBaseViewCore, request: SettlementContractRequest, resMethod: (result: SettlementContractResult) => void): void {
	// 	return this.doPost(viewCore, '/settlement/authpaypay', request, resMethod);
	// }

	/**
	 * PayPay完了処理（完了画面遷移）
	 * @param viewCore 
	 * @param request 
	 * @param resMethod 
	 */
	public redirectComplete(viewCore: WprBaseViewCore, request: SettlementContractRequest, resMethod: (result: SettlementContractResult) => void): void {
		return this.doPost(viewCore, '/settlement/redcomp', request, resMethod);
	}

	public addErrorHistory(viewCore: WprBaseViewCore, request: SettlementContractRequest, resMethod: (result: SettlementContractResult) => void): void {
		return this.doPost(viewCore, '/settlement/adderr', request, resMethod);
	}
	// --------------------------------------------------------------------------
}